export default __webpack_public_path__ + "static/media/check_green_circle.ea230591.svg";